import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Cart, CheckTaxExemptions, Customer, StartCheckout } from 'src/app/shop';

@Component({
    selector: 'app-cart-summary',
    templateUrl: './cart-summary.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CartSummaryComponent {
  @Input() cartLoading: boolean = true;
  @Input() cart!: Cart;
  @Input() customer?: Customer | null;
  @Input() customerLoaded: boolean = false;
  @Input() prefix: string = 'winkelwagen-overzicht';
  @Input() hasVatNumber: boolean = false;

  @Input({ required: true }) exemptionsChecked!: boolean;
  @Input({ required: true }) exemptionsChecking!: boolean;
  @Input({ required: true }) exemptionsValid!: boolean;

  constructor(private store: Store) {}

  parseFloat(num: string | number) {
    if (typeof num === 'number') {
      return num;
    }
    return parseFloat(num);
  }

  checkout(force: boolean = false) {
    if (this.hasVatNumber && this.customer && !force) {
      this.store.dispatch(CheckTaxExemptions());
      return;
    }
    this.store.dispatch(StartCheckout());
  }
}
